import { render, staticRenderFns } from "./dadata-city-autocomplete.vue?vue&type=template&id=5dd54a23&"
import script from "./dadata-city-autocomplete.vue?vue&type=script&lang=js&"
export * from "./dadata-city-autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./dadata-city-autocomplete.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/dadata-autocomplete/dadata-city-autocomplete.vue
// module id = 395
// module chunks = 0